<template>
    <div>
        <az-break-title title="Reduções" />

        <div>
            <div class="row mb-3">
                <div class="col col-12 col-md-6">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="button" @click="copiar()">
                                    <i class="fas fa-copy"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button
                        type="button"
                        class="btn btn-outline-success"
                        @click="incluir ()">
                        Incluir Redução
                    </button>
                </div>
            </div>
        </div>

        <az-empty-state v-if="!lista || !lista.length" />

        <div class="list-group mb-3 az-anime-surgir mb-3">
            <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                <span>
                    <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">{{ dado.search }}</a>
                    <span class="badge badge-secondary ml-2" v-if="dado.id_reducao">
                        #{{ dado.id_reducao }}
                    </span>
                </span>
                <span class="d-flex">
                    <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                        <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="'ativo-' + id"
                        v-model="dado.fl_ativo"
                        @change="toggle(dado)"
                        />
                        <label class="custom-control-label" :for="'ativo-' + id"></label>
                    </div>

                    <div v-else-if="dado.in_regra_ordem">
                        <span class="badge badge-secondary ml-2" v-if="dado.id_reducao" title="Ordem">
                            <i class="fa-solid fa-arrow-down-1-9 fa-fw mr-2"></i>
                            {{ dado.in_regra_ordem }}
                        </span>
                    </div>
                </span>
            </li>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="editarReducaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Redução</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-10">
                                <az-input 
                                    label="Título"
                                    placeholder="Não definido..."
                                    v-model="item.st_titulo" />
                            </div>

                            <div class="col col-12 col-md-2">
                                <az-input 
                                    label="Ordem"
                                    type="number"
                                    placeholder="Não definida..."
                                    v-model="item.in_regra_ordem" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    label="Especialidade"
                                    placeholder="Todas as Especialidades..."
                                    type="select" 
                                    optionsMode="esp-ativas"
                                    optionsName="esp-ativas"
                                    optionsData="id_especialidade"
                                    :optionsReload="true"
                                    v-model="item.id_especialidade" />
                            </div>
                        </div>

                        <az-sub-title title="Quando" />

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Classificação"
                                    service="classe_procedimentos.index"
                                    type="select"
                                    optionsMode="aql"
                                    :optionsSync="false"
                                    optionsData="id_classe_procedimento"
                                    optionsDisplay="search"
                                    :validate="validate"
                                    :edicao="!item.id_procedimento"
                                    v-model="item.id_classe_procedimento">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.id_classe_procedimento">
                                            <span class="input-group-text">#{{ item.id_classe_procedimento }}</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Procedimento"
                                    :validate="validate"
                                    type="autocomplete"
                                    optionsName="procedimentos.agenda" 
                                    optionsMode="aql"
                                    optionsData="id_procedimento"
                                    optionsDisplay="search"
                                    :optionsSync="false"
                                    :optionsInitial="item.procedimento ? item.procedimento.search : ''"
                                    :edicao="!item.id_classe_procedimento"
                                    v-model="item.id_procedimento">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.id_procedimento">
                                            <span class="input-group-text">#{{ item.id_procedimento }}</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <az-sub-title title="Reduzir" />

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Classificação"
                                    service="classe_procedimentos.index"
                                    type="select"
                                    optionsMode="aql"
                                    :optionsSync="false"
                                    optionsData="id_classe_procedimento"
                                    optionsDisplay="search"
                                    :validate="validate"
                                    :edicao="!item.id_procedimento_reduzido"
                                    v-model="item.id_classe_procedimento_reduzido">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.id_classe_procedimento_reduzido">
                                            <span class="input-group-text">#{{ item.id_classe_procedimento_reduzido }}</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Procedimento"
                                    :validate="validate"
                                    type="autocomplete"
                                    optionsName="procedimentos.agenda" 
                                    optionsMode="aql"
                                    optionsData="id_procedimento"
                                    optionsDisplay="search"
                                    :optionsSync="false"
                                    :optionsInitial="item.procedimento_reduzido ? item.procedimento_reduzido.search : ''"
                                    :edicao="!item.id_classe_procedimento_reduzido"
                                    v-model="item.id_procedimento_reduzido">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="item.id_procedimento_reduzido">
                                            <span class="input-group-text">#{{ item.id_procedimento_reduzido }}</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <az-sub-title title="Redução" />

                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Percentual da Primeira Ocorrência"
                                    type="money"
                                    required
                                    :validate="validate"
                                    :precision="6"
                                    v-model="item.dc_desconto_primeira_repeticao" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Percentual das Ocorrências Subsequentes"
                                    type="money"
                                    required
                                    :validate="validate"
                                    :precision="6"
                                    v-model="item.dc_desconto_demais_repeticoes" />
                            </div>

                            <div class="col col-12 col-md-4">
                                <az-input
                                    label="Aplicar Sobre"
                                    type="select"
                                    required
                                    :validate="validate"
                                    optionsData="id"
                                    :optionsList="[
                                        { id: 'TOT', search: 'Valor Total' },
                                        { id: 'CO', search: 'Custo Operacional' },
                                        { id: 'C+H', search: 'Custo Operacional + Honorário Médico' },
                                    ]"
                                    v-model="item.st_tipo_reducao_reduzido" />
                            </div>
                        </div>

                        <div class="form-row mt-3">
                            <div class="col col-12">
                                <az-input 
                                    type="checkbox-group"
                                    label="Redução somente entre procedimentos iguais"
                                    v-model="item.fl_mesmo_procedimento" />
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />

                        <br><br><br><br><br><br><br><br><br><br>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item && item.id_reducao" model="reducao" :id="item.id_reducao" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item.id_reducao ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <copiar-cadastro 
            ref="copiador" 
            :lista="lista" 
            :destinos="operadoras" 
            :id="id_operadora" 
            chave="id_operadora"
            service="reducoes" />

        <pre v-if="false">{{ dados }}</pre>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzBreakTitle from "../../../util/AzBreakTitle.vue";
import AzEmptyState from "../../../util/AzEmptyState.vue";
import AzInput from "../../../shared/forms/AzInput.vue";
import AzSubTitle from "../../../util/AzSubTitle.vue";
import AzSubmit from "../../../util/AzSubmit.vue";
import CopiarCadastro from '../../shared/CopiarCadastro.vue';
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';
import FiltroModel from '../../shared/FiltroModel.vue';

export default {
    data() { 
        return { 
            dados: null, 
            search: "", 
            item: null, 
            validate: false, 
            viewMode: "A",
        }
    },

    computed: {
        lista: {
            get() {
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(" ", ".*");
                let match = parts;
                let reg = new RegExp(match, "i");

                return this.dados && this.dados.length
                ? this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo)
                    .filter(item => {
                        return !this.search || reg.test(JSON.stringify(item));
                    })
                : null;
            },
            set(newLista) {
                this.dados = newLista;
            }
        },

        lista_opcoes_filtro: function () { 
            /*
            {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
            {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
            {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
            {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
            {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            */
           
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Plano', service: 'planos.index', parms: { id_operadora: this.id_operadora } },
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
            ];

            return opcoes;
        }
    },

    props: ['id_operadora', 'operadoras'],

    components: { 
        AzBreakTitle, 
        AzEmptyState,
        AzInput,
        AzSubTitle, 
        AzSubmit,
        CopiarCadastro,
        AzAuditLogButton,
        FiltroModel
    },

    methods: { 
        copiar() { 
            this.$refs.copiador.copiar();
        },

        incluir() { 
            this.validate = false;
            this.item = null; 

            this.$nextTick(() => { 
                this.item = {
                    id_reducao: null,
                    id_operadora: this.id_operadora,
                    fl_ativo: true,
                    id_classe_procedimento: "",
                    id_procedimento: "",
                    id_classe_procedimento_reduzido: "",
                    id_procedimento_reduzido: "",
                    dc_desconto_primeira_repeticao: 0, 
                    dc_desconto_demais_repeticoes: 0, 
                    st_tipo_reducao_reduzido: "TOT",
                    filtros: [], 
                };

                $("#editarReducaoModal").modal("show");
            });
        },

        editar(item) { 
            this.validate = false;
            this.item = null;

            this.$nextTick(() => { 
                this.item = _.cloneDeep(item);
                $('#editarReducaoModal').modal('show');
            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'reducoes',
                parms: { 
                    where: { id_operadora: this.id_operadora },
                }
            });
        },

        toggle(item) {
            this.$util.toggle(this, { 
                service: 'reducoes',
                dados: item, 
            });
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'reducoes',
                dados: this.item, 
                modal: 'editarReducaoModal',
                reload: true, 
            });
        }
    },

    mounted() { 
        this.load(); 
    }

}
</script>